module.exports = __webpack_public_path__ + "img/list_button.4facd203.png";